import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { CloseIcon } from '@repo/ui/Icon';
import styled from 'styled-components';
import { useTheme } from 'styled-components';

import { useGetMyProfile, useUpdateNsfwDisable } from 'services/hooks/user';
import { closeModal } from 'store/modalStackStore';

export default function MinorRestrictionModalBody({ onConfirm }: { onConfirm?: () => void }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { data: userProfile } = useGetMyProfile();

  const { mutate: updateNsfwDisable } = useUpdateNsfwDisable(userProfile?.id);

  const handleConfirm = () => {
    onConfirm?.();
    closeModal();
  };

  useEffect(() => {
    return () => {
      updateNsfwDisable();
    };
  }, []);

  return (
    <SWrapper>
      <div className="info-modal-header">
        <button onClick={handleConfirm} className="close-btn">
          <CloseIcon size={24} color={theme.color.icon.icon_2} />
        </button>
      </div>
      <div className="content-box">
        <h1 className="title">{t('chat.profile_my_verify_youth_protection_toast_title')}</h1>
        <div className="warning-image-box">
          <div className="warning-image">
            <span>19</span>
          </div>
        </div>
        <div className="info-text-box">
          <p className="description">
            <Trans i18nKey={'chat.profile_my_verify_youth_protection_toast'} />
          </p>
        </div>
      </div>
    </SWrapper>
  );
}

const SWrapper = styled.div`
  background: ${({ theme }) => theme.color.popup.background};
  padding-bottom: 30px;
  width: 100%;
  max-width: 400px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .info-modal-header {
    padding: 0px 25px;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .content-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    margin-top: 12px;
    padding: 0px 25px 16px 25px;
  }

  .warning-image-box {
    display: flex;
    justify-content: center;
  }

  .warning-image {
    display: flex;
    width: 120px;
    height: 120px;
    padding: 3px 4px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    border: 4px solid ${({ theme }) => theme.color.static.adult};

    span {
      color: ${({ theme }) => theme.color.text.default};
      text-align: center;
      font-size: 60px;
      font-weight: 700;
    }
  }

  .title {
    ${({ theme }) => theme.font.head5_sb};
    color: ${({ theme }) => theme.color.text.default};
  }

  .info-text-box {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .description {
      text-align: center;
      ${({ theme }) => theme.font.body2_r};
      color: ${({ theme }) => theme.color.text.TXT_3};
    }
  }

  @media screen and (max-width: 429px) {
    max-width: initial;
    min-width: initial;
    height: 100dvh;
  }
`;
